import ContactHero from "../components/Contacthero";
import ContactInfo from "../components/ContactInfo";
import Navbar from "../components/Navbar";
import Footer from "../components/FooterCTA";
import ContactForm from "../components/ContactForm";
import Container from "../components/Container";
import GlobalPresenceMap from "../components/map";

const Contact = ({ openForm }) => {
  return (
    <div className="w-full overflow-x-hidden">

      <Navbar openForm={openForm} />

      <ContactHero />

      <section className="bg-white w-full mt-3 py-8 sm:py-12 md:py-14 lg:py-16 px-4 sm:px-6 lg:px-8 ">

        <div
          className="
            relative
            mx-auto
            w-full
            max-w-3xl md:max-w-4xl lg:max-w-5xl xl:max-w-6xl
            bg-white
            rounded-xl sm:rounded-2xl
            shadow-lg sm:shadow-xl shadow-gray-200/60
            px-4 sm:px-8 md:px-10 lg:px-12 xl:px-14
            py-5 sm:py-7 md:py-8 lg:py-9
            grid grid-cols-1 md:grid-cols-2
            gap-8 sm:gap-10 lg:gap-12 xl:gap-16
            items-stretch
          "
        >

          {/* Divider - only shows on md+ where columns sit side by side */}
          <div
            className="
              hidden md:block
              absolute
              top-8 bottom-8
              left-1/2
              w-px
              bg-gradient-to-b
              from-transparent
              via-gray-200
              to-transparent
            "
          />

          {/* Contact Info */}
          <div className="flex flex-col min-w-0 w-full h-full order-2 md:order-1 ">
            <ContactInfo />
          </div>

          {/* Contact Form */}
          <div className="flex flex-col min-w-0 w-full h-full order-1 md:order-2 mt-10 md:mt-0">
            <ContactForm />
          </div>

        </div>

      </section>
      <Footer />

    </div>
  );
};

export default Contact;